// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:host ::ng-deep .ql-container {
    font-size: 15px;
}

:host ::ng-deep .ql-editor{
    font-size: 15px;
    min-height: 80px;
    
}

:host ::ng-deep .ah-quill-editor .ql-editor{
    font-size: 15px;
    min-height: 120px;
    
}


:host ::ng-deep quill-view .ql-editor{
    font-size: 15px;
    min-height: 20px;
    padding: 0px;
}

`, "",{"version":3,"sources":["webpack://./src/app/contact-detail/activity-history/activity-history.component.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,iBAAiB;;AAErB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":["\n\n:host ::ng-deep .ql-container {\n    font-size: 15px;\n}\n\n:host ::ng-deep .ql-editor{\n    font-size: 15px;\n    min-height: 80px;\n    \n}\n\n:host ::ng-deep .ah-quill-editor .ql-editor{\n    font-size: 15px;\n    min-height: 120px;\n    \n}\n\n\n:host ::ng-deep quill-view .ql-editor{\n    font-size: 15px;\n    min-height: 20px;\n    padding: 0px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
